/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  Dropdownwrapper,
} from "../CreateEvent/style";

import {  closeIcon,  CloseIconBranding,  PromotionalDocIcon,  RecognitionCloseIcon, UploadHDMIcon, WeekDropdownIcon} from "../../utils/icons";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";
import { Border } from "../Journeys/styles";
import { FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import { Main } from "../AdminTeamCreation/styles";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import { RadioButtonNew, RadioButtonWrapper } from "../RecogntionAdmin/styles";
import { ActionButton,  WeekContainer, WeekWrapper } from "../WellnessChallenge/styles";
import { InputImage, RemoveImageV2, UploadPhotoContainer } from "../common/CommonImageUploader/style";
import { SaveAffirmationDetails, ConvertCsvToJson,GetAffirmationsDetailsAndPillars,GetDailyAffirmations,GetChallengeLevel } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../utils/methods";
import Waiting from "../Waiting";
import CSVList from "../PeopleHomeV2/CSVList";
import {ImageUrl} from "../../utils/constants";
import { PillarContent } from "./style";
import { showSuccessToast } from "../UserDashboard/ToastHelper";
class EditAffirmationForm extends Component {
  constructor(props) {
    super(props);
    this.csvInputRef = React.createRef();   
    const locationState = this.props.history.location?.state || {};
    
    this.state = {
      month: "",
      url: "",
      pillar_Id: locationState.selectedPillarId || null,
      selectedCategory: locationState.selectedPillarId || null,
      preselectedPillar: locationState.selectedPillarData || null,
      options: ["", ""], 
      imageName: "",
      imgSrc: "",
      selectedValues:[],
      buttonstatus: false,
      step: 1,
      affirmationDetails:[],
      file: null,
      fileName: "",
      csvUpload: false,
      showBack:false,
      buttonClickScrollTop:false,
      levelOpen:true,
      loading:false,
      levelNumber:null,
      printSampleBiometricCSV:false,
      selectedOption: 0,
      isImageChanged: false,
      // selectedCategory: null,
      formDetails:[],
      active: false,
      weeksData: [],
      expandedWeek: 0, // index of currently expanded week (0-based)
    };

  }

  FetchWellbeingPillarAndDetails = async()=>{
    const currentYear = new Date().getFullYear();
    try {
      const res = await fetchApi(`${GetAffirmationsDetailsAndPillars}/${currentYear}`, "GET");
      if(res.success === 'success'){
        this.setState({formDetails:res.data});
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  // mapApiWeeks = (apiWeeks) => {
  //   return apiWeeks.map((week) => ({
  //     week: week.week,
  //     days: week.days.map((day) => ({
  //       date: day.date,
  //       affirmation: day.affirmation || ""
  //     }))
  //   }));
  // };


  mapApiWeeks = (apiWeeks) => {
    window.console.log("",)
    return apiWeeks?.map((week) => ({
      week: week.week,
      days: week.days?.map((day) => {
        const dateObj = new Date(day.date); // backend gives yyyy-mm-dd
  
        const formattedDate = this.formatDate(dateObj); 
        // formatDate should return DD/MM/YYYY
  
        return {
          date: formattedDate,
          affirmation: day.affirmation || ""
        };
      })
    }));
  };
  



  
  FetchDailyAffirmationDetails = async(pillarId)=>{
    const currentYear = new Date().getFullYear();
    try {
      const res = await fetchApi(`${GetDailyAffirmations}/${pillarId}/${currentYear}`, "GET",null,additionalHeaders={'Content-Type': ''});
      //   const res = await fetchApi(`${GetDailyAffirmations}/${pillarId}/${currentYear}`, "GET");
      if(res.success === 'success'){
        // this.setState({affirmationDetails:res.data});
        this.setState({
          affirmationDetails: res.data,
          //   month: apiData.month,
          weeksData: this.mapApiWeeks(res.data.weeks)
        });
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }
    



  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.preselectedPillar &&
      prevState.formDetails !== this.state.formDetails &&
      this.state.formDetails.length > 0
    ) {
      const matched = this.state.formDetails.find(
        (p) => p.pillar_id === this.state.preselectedPillar.pillar_id
      );
  
      if (matched) {
        this.onPillarSelect(matched);
      }
    }
  }
  
  generateWeeksData = (year, monthIndex) => {
    const daysInMonth = this.getDaysInMonth(year, monthIndex);
    const weeks = [];
  
    let week = { week: 1, days: [] };
  
    for (let day = 1; day <= daysInMonth; day++) {
      const dateObj = new Date(year, monthIndex, day);
      const date = this.formatDate(dateObj);   // DD/MM/YYYY
      // const date = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
      // const date = new Date(year, monthIndex, day)
      //   .toISOString()
      //   .split("T")[0]; 
      week.days.push({
        date,
        affirmation: ""
      });
  
      if (week.days.length === 7) {
        weeks.push(week);
        week = { week: weeks.length + 1, days: [] };
      }
    }
  
    if (week.days.length > 0) {
      weeks.push(week);
    }
    this.setState({ weeksData: weeks });
    return weeks;
  };
  
  getDaysInMonth = (year, monthIndex) => {
    window.console.log("")
    return new Date(year, monthIndex + 1, 0).getDate();
  };   
  
  componentDidMount(){
    this.FetchWellbeingPillarAndDetails();
    // if ( this.props.history.location?.state?.category_Id ) {
    //   this.setState({ pillar_Id: this.props.history.location?.state?.category_Id  });
    //   this.GetChallengeLevelNumber();
    // }
  }

  printAction = (bool) => {
    this.setState({printSampleBiometricCSV:bool});
  }

  toggleWeek = (weekIndex) => {
    this.setState((prevState) => ({
      expandedWeek: prevState.expandedWeek === weekIndex ? null : weekIndex
    }));
  };

  onChangeInput = (e) => {
    if(e.target.value.charAt(0) !== ' '){
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  onChangeInputDay = (weekIndex, dayIndex, field, value) => {
    this.setState((prevState) => {
      const weeksData = [...prevState.weeksData];
      weeksData[weekIndex] = {
        ...weeksData[weekIndex],
        days: weeksData[weekIndex].days?.map((day, i) =>
          i === dayIndex ? { ...day, [field]: value } : day
        )
      };
      return { weeksData };
    });
  };
  

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };


  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
      isImageChanged: true,  
    });
  }

  GetChallengeLevelNumber = async()=>{
    const { pillar_Id } = this.state;
    let apiUrl = GetChallengeLevel + "/" + pillar_Id;
    try{
      const res = await fetchApi(apiUrl, "GET");

      if(res?.status === "success"){
        toast.success(res.data[0]);
        this.setState({challenge_level:res.data.current_level});

      }else{
        toast.error(res.data.message);
      }
    }catch(error){
      toast.error(error);
    }
  }



  formatDateForApi = (ddmmyyyy) => {
    // expects "DD/MM/YYYY"
    if (!ddmmyyyy) return "";
  
    const [dd, mm, yyyy] = ddmmyyyy.split("/");
  
    return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
  };
  

  formatWeeksForApi = () => {
    window.console.log("")
    return this.state.weeksData?.map((week) => ({
      week: week.week,
      days: week.days?.map((day) => ({
        date: this.formatDateForApi(day.date),
        affirmation: day.affirmation
      }))
    }));
  };
  
  saveAffirmationDetails = () => {
    const { selectedCategory, imgSrc } = this.state;
    this.setState({ loading: true });
    const payload = {
      pillar_id: selectedCategory,
      thumbnail_base64: this.state.isImageChanged ? imgSrc : "",
      weeks: this.formatWeeksForApi()
    };
    this.PostAffirmationDetails(payload);
  };

  
  PostAffirmationDetails = async (payload) => {
    try {
      const res = await fetchApi(
        SaveAffirmationDetails,
        "POST",
        payload
      );
      if (res?.success === "success") {
        showSuccessToast(res.message);
        // toast.success(res.message);
        this.props.history.push("/company/wellness", {
          activeTab: "Library",
          activeLibraryTab: "Affirmations",
        });
        // this.props.history.push("/company/wellness");
      } else {
        toast.error(res?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Failed to save affirmations");
    } finally {
      this.setState({ loading: false });
    }
  };
  

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop:true });
  };

  close = () =>(
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{maskType: "alpha",}}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  )

  redirect=()=>{
    this.props.history.push("/company/wellness", {
      activeTab: "Library",
      activeLibraryTab: "Affirmations",
    });
    // this.props.history.goBack();
  }
  
  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect }>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#DA6C74')}</ManagerIconContainer>
      </div>Daily Affirmations
    </FormHeading>
  );

  getMonthNumber = (monthName) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  
    return months.indexOf(monthName); 
  };

  onPillarSelect = (pillar) => {
    const today = new Date();
    const year = today.getFullYear();
    const monthNumber = this.getMonthNumber(pillar.month);
    this.setState(
      {
        selectedCategory: pillar.pillar_id,
        month: pillar.month,
        selectedOption: 0,
        imgSrc: pillar.thumbnail_path ? `${ImageUrl}/${pillar.thumbnail_path}` : "",
        totalDays: pillar.total_days_in_month,
        monthDisabled: true,
      },
      () => {
        // Only generate weeks if Manual mode
       
        this.generateWeeksData(year, monthNumber);
      
      }
    );
  };
  
      
  stepOneForm = () => {
    const {
      step,
      formDetails
    } = this.state;

    const { t } = this.props;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container  color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="Create-affirmations"/>
            </div>
            <div className="form">
             
              <div className="formBody">
                <div style={{display:"flex", flexDirection:"column"}}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Select Wellbeing Pillar")}{<span>*</span>}</StyledLabel>
                  <Dropdownwrapper>
                    {formDetails?.map((item) => {
                      {/* const isDisabled = item.is_filled; */}
                      return(
                        <PillarContent 
                          // title={isDisabled ? "Affirmations already created for this pillar" : ""}
                          key={item?.pillar_id}
                          selected={this.state.selectedCategory === item.pillar_id}
                          // disabled={isDisabled}
                          onClick={() => {
                            // if (isDisabled) return;
                            this.onPillarSelect(item);
                            // this.setState({ selectedCategory: item.pillar_id,month:item.month });
                          }} >
                          <img src={`${ImageUrl}/${item.wellbeing_pillar.icon}`} />
                          <div className="listContent">{item.wellbeing_pillar.pillar_title}</div>
                        </PillarContent>)})}
                  </Dropdownwrapper>
                </div>


                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/>
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Month")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Month will be based on wellbeing pillar you select")}
                    name="month"
                    disabled
                    style={{
                      background: "#F5F5F5",
                      cursor: "not-allowed",
                    }}
                    // onChange={this.onChangeInput}
                    value={this.state.month}
                    maxLength="30"
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                </InputContainer> 
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/>
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Upload Thumbnail")}{<span>*</span>}</StyledLabel>
                <CommonImageUploader
                  imgSrc={this.state.imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onChange}
                  onRemoveImage={this.removePhoto}
                />
               
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleRadioButton = (val) => {
    this.setState({ selectedOption: val }, () => {
      if (val === 1 && this.state.selectedCategory) {
        this.FetchDailyAffirmationDetails(this.state.selectedCategory);
      }
    });
  };

  getSelectedMonthNumber = () => {
    const monthMap = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };
  
    return monthMap[this.state.month];
  };

  // parseCSVDate = (dateStr) => {
  //   if (!dateStr) return null;
  
  //   const [day, month, year] = dateStr.split("/");
  
  //   return new Date(year, month - 1, day); // JS month is 0-based
  // };



  parseCSVDate = (value) => {
    if (!value) return null;
  
    value = value.toString().trim();
  
    let day, month, year;
  
    // 1️⃣ DD/MM/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      [day, month, year] = value.split("/");
    }
  
    // 2️⃣ Excel format YYYY-MM-DD
    else if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      [year, month, day] = value.split("-");
    }
  
    // ❌ Anything else → invalid
    else {
      return null;
    }
  
    const date = new Date(year, month - 1, day);
  
    // Final validity check
    if (
      date.getFullYear() != year ||
      date.getMonth() != month - 1 ||
      date.getDate() != day
    ) {
      return null;
    }
  
    return date;
  };
  
  

  handleFiles = (e) => {
    this.setState({
      file: "",
      fileName: "",
      csvUpload: false,
    });

    let file = e.target.files[0];
    if (!file) return;

    const fileName = file?.name;
    let checkCSV = fileName.split(".");
    if (checkCSV[checkCSV.length - 1].toLowerCase() !== "csv") {
      toast.error("Please select .csv format only");
      document.getElementById("csv-upload-input").value = "";
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: reader.result ? reader.result : "data:",
        fileName: fileName,
        csvUpload: true,
        // data: [
        //   { fname: "", lname: "", mail: "" } // initial structure
        // ],
      }, () => {
        // ✅ Once state is set, immediately call your API
        this.PostCsvToJson();
      });
    };
  };

  // formatDate = (dateObj) => {
  //   const y = dateObj.getFullYear();
  //   const m = String(dateObj.getMonth() + 1).padStart(2, "0");
  //   const d = String(dateObj.getDate()).padStart(2, "0");
  //   return `${y}-${m}-${d}`;
  // };



  formatDate = (dateObj) => {
    const dd = String(dateObj.getDate()).padStart(2, "0");
    const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
    const yyyy = dateObj.getFullYear();
  
    return `${dd}/${mm}/${yyyy}`;
  };
  

  resetCsvUpload = () => {
    this.setState({
      csvUpload: false,
      file: "",
      fileName: "",
    });
    if (this.csvInputRef?.current) {
      this.csvInputRef.current.value = "";
    }
  };

  PostCsvToJson = async () => {
    const { file, month } = this.state;
    const payload = { csv_base64: file };
    const today = new Date();
    const year = today.getFullYear();
    const monthNumber = this.getMonthNumber(month);
  
    try {
      const res = await fetchApi(ConvertCsvToJson, "POST", payload);
  
      if (res?.status !== "success") {
        toast.error(res.data.message);
        return;
      }
  
      const selectedMonth = this.getSelectedMonthNumber();
      // ❗ Validate all CSV dates
      for (let row of res.data.data) {
        const csvDate = this.parseCSVDate(row.date);
  
        if (!csvDate) {
          toast.error(
            "Invalid date format in CSV. Please use DD/MM/YYYY (e.g. 05/01/2026)."
          );
          this.resetCsvUpload();
          return;
        }
  
        if (csvDate.getMonth() !== selectedMonth) {
          toast.error(
            `CSV contains dates outside ${month}. Please upload a file where all dates are in ${month} and in DD/MM/YYYY format.`
          );
          this.resetCsvUpload();
          return;
        }
      }

      const weeksData =  this.generateWeeksData(year, monthNumber);
      
      // ✅ If validation passes → populate weeks
      // const weeksData = Array(4).fill().map(() => ({
      //   days: Array(7).fill().map(() => ({
      //     affirmation: "",
      //     date: "",
      //   }))
      // }));

      const csvMap = {};
      res.data.data.forEach((row) => {
        const dateObj = this.parseCSVDate(row.date);
        if (dateObj) {
          const formatted = this.formatDate(dateObj);
          csvMap[formatted] = row.affirmation;
        }
      });
      
      // Fill calendar
      weeksData.forEach((week) => {
        week.days.forEach((day) => {
          if (csvMap[day.date]) {
            day.affirmation = csvMap[day.date];
          }
        });
      });
      
      this.setState({ weeksData, expandedWeek: 0 });
  
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };
  

  removeFile = () => {
    const fileInput = document.getElementById('new-employee-file');
    if (fileInput) {
      fileInput.value = '';
    }
  
    // Reset state
    this.setState({
      csvUpload: false,
      fileName: '',
      file: ''
    });
  };

  getCSVHeaders = () => {

    const csvHeaders = [
      { label: "Date", key: "date" },
      { label: "Affirmation", key: "affirmation" },
      
    ];
    return csvHeaders;
  };

  stepTwoForm = () => {

    const {
      step,
      selectedOption,
      fileName,
      csvUpload,
      printSampleBiometricCSV
    } = this.state;
    return(
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="Create-affirmations"/>
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">
                  {this.props.t("How would you like to add affirmation?")}
                  {<span>*</span>}
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButtonNew
                        type={"radio"}
                        checked={selectedOption === 0}
                        onChange={() => this.toggleRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"CSV upload"}</div>              
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButtonNew
                        type={"radio"}
                        checked={selectedOption === 1}
                        onChange={() => this.toggleRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"Manual upload"}</div>              
                    </div>
                  </RadioButtonWrapper>
                </div>
               
                {selectedOption === 0 ? <>
                  <Border style={{ background: '#EFEFEF', margin: '4px 0px' }} />
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Add CSV document")}{<span>*</span>}</StyledLabel>
                  <UploadPhotoContainer showBorder={false}>
                    <div className="innerDivImageContainer">
                      {csvUpload ? (
                        <RemoveImageV2>
                          <div className="uploadImage">
                            <div className="promotional-doc">
                              <div className="promotional-doc-icon">{PromotionalDocIcon()}</div>
                              <div>
                                <span
                                  className="promotional-doc-name"
                                  title={fileName}
                                >
                                  {fileName}
                                </span>
                              </div>
                            </div>
                            <div className="main-div" onClick={this.removeFile}>
                              <div className="icon-div">
                                <div className="sub-icon-div">
                                  {CloseIconBranding("#DA6C74", "8", "8")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </RemoveImageV2>
                      ) : (
                        <div className="uploadImage">
                          <InputImage
                            className="edit-profile-pic"
                            imageReload={1}
                            style={{ background: "unset", color: "#184A61" }}
                          >
                            <div
                              className="middle-section"
                              onClick={() => this.csvInputRef.current.click()}
                            >
                              <div>{UploadHDMIcon()}</div>
                              <div className="title">{("Upload File")}</div>
                              <div className="sub-title">{("(.csv)")}</div>
                            </div>
                            <input
                              className="input-section"
                              id="csv-upload-input"
                              type="file"
                              accept=".csv"
                              multiple={false}
                              onChange={this.handleFiles}
                              ref={this.csvInputRef}
                              style={{ display: "none" }}
                            />
                          </InputImage>
                        </div>
                      )}
                    </div>
                  </UploadPhotoContainer>
                </>  :null}

                {selectedOption === 0 && !csvUpload ? <ActionButton isBorderColor={"1px solid #DA6C74"}
                  onClick={()=>this.setState({printSampleBiometricCSV:true})}>
                  Download Sample
                </ActionButton> : null}
   
                { ( csvUpload  && selectedOption === 0)  ||   selectedOption === 1 ? <WeekWrapper styel={{ marginTop: "20px" }} isDayWeight={"400"} isDayText={"16px"}>
                  {this.state.weeksData?.map((week, weekIndex) => (
                    <div key={weekIndex}>
                      {/* Week Header */}
                      <WeekContainer
                        isDayText={"16px"}
                        onClick={() => this.toggleWeek(weekIndex)}
                        style={{ cursor: "pointer", marginTop: "20px" }}
                      >
                        <div className="weeekText">Week {weekIndex + 1}</div>
                        {/* <div className="weeekText">Week {week.week}</div> */}
                        <div
                          style={{
                            transform:
                              this.state.expandedWeek === weekIndex
                                ? "rotate(0deg)"
                                : "rotate(180deg)",
                            transition: "transform 0.3s"
                          }}
                        >
                          {WeekDropdownIcon("#DA6C74")}
                        </div>
                      </WeekContainer>
                  
                      {weekIndex !== this.state.weeksData.length - 1 && (
                        <Border style={{ background: "#EFEFEF", margin: "8px 0px" }} />
                      )}
                  
                      {/* Days */}
                      {/* {this.state.expandedWeek === weekIndex &&
                   week.days.map((day, dayIndex) => (
                     <React.Fragment key={dayIndex}>
                       {weekIndex === this.state.weeksData.length - 1 && (
                         <Border
                           style={{
                             background: "#EFEFEF",
                             margin: "20px 0px 8px 0px",
                             display: "flex"
                           }}
                         />
                       )}
             
                       <div className="dayText">
                         Day {(weekIndex * 7) + dayIndex + 1}  
                         <span style={{ color: "#989898", fontSize: "16px", marginLeft: "8px" }}>
                           ({day.date})
                         </span>
                       </div>

                       <InputContainer>
                         <StyledInputV2
                           placeholder={this.props.t("Enter Tip")}
                           value={day.affirmation}
                           onChange={(e) =>
                             this.onChangeInputDay(
                               weekIndex,
                               dayIndex,
                               "affirmation",
                               e.target.value
                             )
                           }
                           maxLength="300"
                           style={{ background: "white" }}
                           pColor="#BDBDBD"
                           color="#184A61"
                           border="1px solid #BDBDBD"
                         />
             
                         <div className="count">
                           {day?.affirmation?.length || 0}/300 | C
                         </div>
                       </InputContainer>

                       <Border style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }} />
                     </React.Fragment>
                   ))} */}

                      {this.state.expandedWeek === weekIndex && (
                        <>
                          {/* Show border once before last week’s days */}
                          {weekIndex === this.state.weeksData.length - 1 && (
                            <Border
                              style={{
                                background: "#EFEFEF",
                                margin: "20px 0px 8px 0px",
                                display: "flex"
                              }}
                            />
                          )}
                                       
                          {week.days?.map((day, dayIndex) => (
                            <React.Fragment key={dayIndex}>
                              <div className="dayText">
                                Day {(weekIndex * 7) + dayIndex + 1}
                                <span style={{ color: "#989898", fontSize: "16px", marginLeft: "8px" }}>
                                  ({day.date})
                                </span>
                              </div>
                    
                              <InputContainer>
                                <StyledInputV2
                                  placeholder={this.props.t("Enter affirmation")}
                                  value={day.affirmation}
                                  onChange={(e) =>
                                    this.onChangeInputDay(
                                      weekIndex,
                                      dayIndex,
                                      "affirmation",
                                      e.target.value
                                    )
                                  }
                                  maxLength="300"
                                  style={{ background: "white" }}
                                  pColor="#BDBDBD"
                                  color="#184A61"
                                  border="1px solid #BDBDBD"
                                />
                      
                                <div className="count">
                                  {day?.affirmation?.length || 0}/300 | C
                                </div>
                              </InputContainer>
                      
                              <Border style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }} />
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    
                    </div>))}

                </WeekWrapper> : null} 
              </div>
            </div>
          </Container>
        </div>
        {printSampleBiometricCSV && <CSVList Title={`${"Sample file"}`} removeCSVData={this.printAction} headers={this.getCSVHeaders()} data={[]} />}
      </Layout>
    )
  }


  isDoneDisabled = () => {
    const { selectedOption, csvUpload, weeksData } = this.state;
    // No option selected
    if (selectedOption === null || selectedOption === undefined) return true;
    // CSV selected but file not uploaded
    if (selectedOption === 0 && !csvUpload) return true;
    // No weeks loaded
    if (!weeksData || weeksData.length === 0) return true;
    // Check all days have affirmations
    for (let week of weeksData) {
      for (let day of week.days) {
        if (!day.affirmation || day.affirmation.trim() === "") {
          return true; // ❌ missing data
        }
      }
    }
    return false; // ✅ everything filled
  };
  

  render() {
    const {
      imgSrc,
      step,
      month,
      loading,
     
    } = this.state;

    if (loading) {
      return <Waiting />;
    }

    return (
      <React.Fragment>
        {step === 1 ? this.stepOneForm() : this.stepTwoForm() }
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!month || !imgSrc} onClick={!month  || !imgSrc ? null: () => this.updateStep(2)}>
               Next
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) :
          (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(1)}
                  margin="auto auto auto 0px">
                 Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" 
                  disabled={this.isDoneDisabled()}
                  onClick={this.isDoneDisabled() ? null : () => this.saveAffirmationDetails()}
                >
                Done
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          ) 
        }
      </React.Fragment>
    );
  }
}

EditAffirmationForm.propTypes = {
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
};

export default (withTranslation()(EditAffirmationForm));